var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.form === 'login')?_c('login-form',{on:{"goRecover":function($event){_vm.form = 'recover'}}}):_vm._e(),(_vm.form === 'recover')?_c('recover-form',{on:{"goLogin":function($event){_vm.form = 'login'}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }